// LangWrapper.js

import i18n from "i18next";
import { useEffect } from "react";
import { resolveLanguage } from "../../i18n/languageUtils";

const LangWrapper = ({ children }) => {
  const detectedLang = resolveLanguage();
  useEffect(() => {
    i18n.changeLanguage(detectedLang);
  }, [detectedLang]);

  return children;
};

export default LangWrapper;
